<template>
  <div>
    <a-select
      :disabled="disabled"
      :multiple="false"
      :placeholder="placeholder"
      :value="value"
      allow-clear
      option-filter-prop="title"
      show-search
      @change="onChange"
    >
      <a-select-option
        v-for="item in records"
        :key="item.id"
        :title="item.contractOfTenancyName"
        :value="item.id"
        >{{ item.contractOfTenancyName }}</a-select-option
      >
    </a-select>
  </div>
</template>

<script lang="ts">
import _ from "lodash";
import { defineComponent, watch } from "vue";
import { LeaseContractService } from "@/views/lease-config/lease-contract/lease-contract.service";
import { LeaseContractSimpleReq } from "@/views/lease-config/lease-contract/lease-contract.interface";
import { useRoute } from "vue-router";
import { onMountedOrActivated } from "@/core/hooks/onMountedOrActivated";

/**
 * 租赁合同选择器
 *
 * 使用方式:
 * <lease-contract-select v-model:value="formRef.contractId"></lease-contract-select>
 */
export default defineComponent({
  isGlobal: true,
  name: "LeaseContractSelect",
  props: {
    value: {
      type: String,
      default: undefined,
    },
    cooperationCompanyId: {
      type: String,
      default: undefined,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    placeholder: {
      type: String,
      default: "请选择",
    },

    projectId: {
      type: String,
      default: undefined,
    },

    contractStatus: {
      type: Array,
      // default: () => ["lyz"],
      default: () => [],
    },
    addRightBizType: {
      type: String,
      default: undefined,
    },
  },
  emits: ["update:value", "change"],
  setup(props, { emit }) {
    const { data: records, run, loading } = LeaseContractService.useSimpList();
    const route = useRoute();
    const onChange = async (id) => {
      emit("update:value", id);
      emit("change", id);
    };

    const search = async () => {
      const req = new LeaseContractSimpleReq();
      if (props.projectId) {
        req.merge({ projectId: props.projectId });
      }
      //供应商id
      if (props.cooperationCompanyId) {
        req.merge({ cooperationCompanyId: props.cooperationCompanyId });
      }
      if (_.isArray(props.contractStatus) && props.contractStatus.length) {
        req.merge({ contractStatus: props.contractStatus.join(",") });
      }
      if (props.addRightBizType) {
        req.merge({ addRightBizType: props.addRightBizType });
      }
      if(route['query']['projectId']){ // 优先展示该项目下的数据
        req.merge({firstDisplayProjectId:route['query']['projectId']});
      }
      req.size = 1000;
      req.current = 1;
      await run(req);
    };

    // 修改项目时, 重新获取项目下的合同
    watch(
      () => props.projectId,
      async () => {
        await search();
      },
      { immediate: true }
    );
    //供应商变化时，要重新获取付款合同
    watch(
      () => props.cooperationCompanyId,
      async (n,o) => {
        if(n && n.length>0){
          await search();
        }
      },
      { immediate: true }
    );

    onMountedOrActivated(async() => {
      await search();
    })
    return {
      records,
      loading,
      onChange,
    };
  },
});
</script>
